import { RoutineType, useCurrentAccount } from '@gripp/shared-logic';
import { Colors, DropDownView, useOpenedState } from '@gripp/shared-ui';
import { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { Button, Text } from 'react-native-paper';
import { useNavigate } from 'react-router-dom';

export const RoutinesToolbar = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { account } = useCurrentAccount();
  const anchorRef = useRef<View>(null);
  const { onOpen, onClose: onAccountFilterClose, isOpened } = useOpenedState();

  const routineTypes = useMemo(() => {
    const _: (keyof typeof RoutineType)[] = [];
    for (const type in RoutineType) {
      _.push(type as keyof typeof RoutineType);
    }
    return _;
  }, []);

  const goToNewRoutine = (type: keyof typeof RoutineType) => {
    navigate(`new-routines/new/${RoutineType[type]}`);
  };

  // Only show the toolbar for global admins
  if (!account?.isGlobalAdmin()) {
    return null;
  }

  return (
    <View ref={anchorRef}>
      <Button
        icon="plus"
        style={styles.button}
        labelStyle={styles.buttonLabel}
        onPress={onOpen}
      >
        {t('routines.createNew')}
      </Button>
      <DropDownView
        anchorRef={anchorRef}
        isVisible={isOpened}
        onDismiss={onAccountFilterClose}
        width={200}
        height={210}
      >
        <View style={styles.containerDropdown}>
          {routineTypes.map((type) => (
            <TouchableOpacity
              style={styles.buttonContainer}
              onPress={() => goToNewRoutine(type)}
              key={type}
            >
              <View style={styles.titleContainer}>
                <Text style={styles.typeText}>
                  {t(`routines.types.${RoutineType[type]}`)}
                </Text>
              </View>
            </TouchableOpacity>
          ))}
        </View>
      </DropDownView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    width: '100%',
    height: 151,
    borderRadius: 12,
    backgroundColor: Colors.white,
    marginBottom: 20,
    justifyContent: 'flex-end',
    paddingRight: 30,
    alignItems: 'center',
  },
  inner: {
    flexDirection: 'column',
  },
  button: {
    borderRadius: 8,
    width: '100%',
    maxWidth: 256,
    height: 44,
    justifyContent: 'center',
  },
  buttonLabel: {
    fontSize: 16,
    fontWeight: '500',
    color: Colors.primaryDark,
  },
  containerDropdown: {
    backgroundColor: Colors.white,
  },
  buttonContainer: {
    flex: 1,
    flexBasis: '50%',
    flexGrow: 1,
    height: 145,
    margin: 10,
    borderRadius: 12,
    borderColor: Colors.black,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 6,
    paddingBottom: 6,
  },
  titleContainer: {
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
  },
  typeText: {
    fontSize: 16,
  },
});
